import { render } from "./paymentsSettings.vue?vue&type=template&id=13da56a1&scoped=true&ts=true"
import script from "./paymentsSettings.vue?vue&type=script&lang=ts"
export * from "./paymentsSettings.vue?vue&type=script&lang=ts"

import "./paymentsSettings.vue?vue&type=style&index=0&id=13da56a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13da56a1"]])

export default __exports__